import React from "react";

const CalendarIcon = (props: any) => {
  return (
    <svg
      {...props}
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1151 19.345V19.445H13.2151H18.1812C19.3563 19.445 20.3121 18.4892 20.3121 17.3141V6.07537C20.3121 4.90031 19.3563 3.94449 18.1812 3.94449H12.5801H12.4801V4.04449V4.57249V4.67249H12.5801H18.1812C18.9549 4.67249 19.5841 5.3021 19.5841 6.07537V17.3141C19.5841 18.0878 18.9545 18.717 18.1812 18.717H13.2151H13.1151V18.817V19.345Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M4.37517 17.4141H4.47517V17.3141V6.07537C4.47517 5.30166 5.10478 4.67249 5.87805 4.67249H8.36349H8.46349V4.57249V4.04449V3.94449H8.36349H5.87805C4.70298 3.94449 3.74717 4.90031 3.74717 6.07537V17.3141V17.4141H3.84717H4.37517Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M20.0482 8.30072V8.20072H19.9482H4.11108H4.01108V8.30072V8.82872V8.92872H4.11108H19.9482H20.0482V8.82872V8.30072Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M7.62776 2.95343V2.85343H7.52776H6.99976H6.89976V2.95343V5.84399V5.94399H6.99976H7.52776H7.62776V5.84399V2.95343Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M17.0472 2.95343V2.85343H16.9472H16.4192H16.3192V2.95343V5.84399V5.94399H16.4192H16.9472H17.0472V5.84399V2.95343Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M8.23642 11.4178V11.3178H8.13642H5.64282H5.54282V11.4178V11.9458V12.0458H5.64282H8.13642H8.23642V11.9458V11.4178Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M13.3763 11.4178V11.3178H13.2763H10.7827H10.6827V11.4178V11.9458V12.0458H10.7827H13.2763H13.3763V11.9458V11.4178Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M18.516 11.4178V11.3178H18.416H15.9224H15.8224V11.4178V11.9458V12.0458H15.9224H18.416H18.516V11.9458V11.4178Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M8.23642 14.535V14.435H8.13642H5.64282H5.54282V14.535V15.063V15.163H5.64282H8.13642H8.23642V15.063V14.535Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M13.3763 14.535V14.435H13.2763H10.7827H10.6827V14.535V15.063V15.163H10.7827H13.2763H13.3763V15.063V14.535Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
      <path
        d="M18.516 14.535V14.435H18.416H15.9224H15.8224V14.535V15.063V15.163H15.9224H18.416H18.516V15.063V14.535Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.2"
      />
    </svg>
  );
};

export default CalendarIcon;
